import styled from "styled-components";

export const SectionWrapper = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	flex-flow: column;
	border-radius: 0.75rem;
	position: relative;
	overflow: hidden;
	isolation: isolate;
	padding: 1rem;
	z-index: 0;

	&::after {
		content: "";
		position: absolute;
		inset: 0;
		background: black url("/assets/blur_blobs.png") no-repeat center center;
		background-size: cover;
		z-index: -1;
		opacity: 0.05;
	}

	// desktop below.
	@media(min-width: 1024px) {
		padding: 4rem;

		&::before {
			content: "";
			position: absolute;
			inset: 0;
			padding: 1px; // This creates the border width
			background: linear-gradient(to bottom, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.1));
			border-radius: 0.75rem;
			-webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
			-webkit-mask-composite: xor;
			mask-composite: exclude;
			z-index: -1;
		}

		// Content background layer
		// &::after {
		// 	content: "";
		// 	position: absolute;
		// 	inset: 0;
		// 	// background: black;
		// 	border-radius: 0.75rem;
		// 	z-index: -2;
		// }

	}
`;
